import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CorrespondenceFunctionStoreActions,
  CorrespondenceFunctionStoreSelectors,
  CorrespondenceFunctionStoreReducer,
} from './index';
import { CorrespondenceDepartmentFunctionDto } from '@cradua/data';

@Injectable()
export class CorrespondenceFunctionFacade {
  constructor(
    private store: Store<
      CorrespondenceFunctionStoreReducer.CorrespondenceFunctionPartialState
    >
  ) {}

  correspondenceFunction$ = this.store.select(
    CorrespondenceFunctionStoreSelectors.getSelected
  );
  correspondenceFunctionError$ = this.store.select(
    CorrespondenceFunctionStoreSelectors.getCorrespondenceFunctionError
  );

  getselected() {
    return this.store.select(CorrespondenceFunctionStoreSelectors.getSelected);
  }

  get isLoadingCorrespondenceFunction() {
    this.store.dispatch(
      CorrespondenceFunctionStoreActions.loadCorrespondenceFunction()
    );
    return this.store.select(
      CorrespondenceFunctionStoreSelectors.loadingCorrespondenceFunction
    );
  }

  get loadCorrespondenceFunction() {
    this.store.dispatch(
      CorrespondenceFunctionStoreActions.loadCorrespondenceFunction()
    );
    return this.store.select(
      CorrespondenceFunctionStoreSelectors.getAllCorrespondenceFunction
    );
  }

  addCorrespondenceFunction(
    newCorrespondenceFunction: CorrespondenceDepartmentFunctionDto[]
  ) {
    this.store.dispatch(
      CorrespondenceFunctionStoreActions.addCorrespondenceFunction({
        newCorrespondenceFunction,
      })
    );
  }

  updateCorrespondenceFunction(
    updateCorrespondenceFunction: CorrespondenceDepartmentFunctionDto[]
  ) {
    this.store.dispatch(
      CorrespondenceFunctionStoreActions.updateCorrespondenceFunction({
        updateCorrespondenceFunction,
      })
    );
  }

  removeCorrespondenceFunction(ids: string[]) {
    this.store.dispatch(
      CorrespondenceFunctionStoreActions.removeCorrespondenceFunction({ ids })
    );
  }
}
